import swal from 'sweetalert';
import JQueryView, { on } from '@/common/views/jqueryView';

export default class OtpView extends JQueryView {
  constructor() {
    super('.simple_form');
  }

  @on({ event: 'input', selector: '#otp' })
  onInputOtp() {
    const otpVal = $('#otp').val() as string;

    $('#otp').val(
      otpVal
        .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
        .replace(/[^0-9]/g, '')
        .slice(0, 6),
    );
  }

  @on({ event: 'click', selector: '#resend_otp' })
  onClickResendOtp(event: JQuery.ClickEvent) {
    if ($('#resend_otp').hasClass('disabled')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      swal({
        title:
          'すでにワンタイムパスワードを再送しております。再度ご確認ください。',
        confirmButtonColor: '#2196F3',
        animation: false,
      });
      return;
    }

    $('#resend_otp').addClass('disabled').css({ opacity: '0.5' });

    swal({
      title: 'ワンタイムパスワードを再送しました。',
      confirmButtonColor: '#2196F3',
      animation: false,
    });

    setTimeout(() => {
      $('#resend_otp').removeClass('disabled').css({ opacity: '1' });
    }, 3000);
  }
}
